import React from 'react';
import { Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SnackWrapper from './style';

const ConsecutiveSnackbars = ({ open, Close, severity, message }) => {
return(
      <SnackWrapper>
        <Snackbar
          key={1}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          autoHideDuration={5000}
          onClose={() => Close(false)}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className={severity}
          message={<span id="message-id">{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => Close(false)}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
      </SnackWrapper>
    );
}

export default ConsecutiveSnackbars;